import * as types from 'types';
import moment from 'moment';

export const checkIsArrival = ({ status, arrivalDate }: { status?: types.TravelStatusEnum; arrivalDate?: string }) => {
  const dateCondition = () => {
    const now = moment();
    return !moment(arrivalDate, 'YYYY-MM-DD').isSameOrAfter(now);
  };

  status = status || types.TravelStatusEnum.None;

  return (
    [types.TravelStatusEnum.None, types.TravelStatusEnum.NoBookingYet].includes(status!) ||
    (status === types.TravelStatusEnum.Booked && dateCondition())
  );
};
